export default __webpack_public_path__ + "835a675794f025dde2995263909d4db8.svg";